import {Injectable} from '@angular/core';

@Injectable()
export class CommandsSoundChannels {
    constructor() {

    }

    channelPan() {
    }

    channelPitch() {
    }

    channelPlaying() {
    }

    channelVolume() {
    }

    pauseChannel() {
    }

    resumeChannel() {
    }

    stopChannel() {
    }
}
